import {OverlayToaster, ToastProps} from '@blueprintjs/core';
import {createRoot} from 'react-dom/client';

export namespace Toaster {
	const instance = OverlayToaster.createAsync({
		position: 'bottom-right',
	}, {
		domRenderer: (toaster, container) => createRoot(container).render(toaster),
	});

	export async function show(props: ToastProps, key?: string): Promise<string> {
		return (await instance).show(props, key);
	}

	export function info(message: string): Promise<string> {
		return show({
			message,
			intent: 'primary',
		});
	}

	export function warning(message: string): Promise<string> {
		return show({
			message,
			intent: 'warning',
		});
	}

	export function error(message: string): Promise<string> {
		return show({
			message,
			intent: 'danger',
		});
	}

	export function success(message: string): Promise<string> {
		return show({
			message,
			intent: 'success',
		});
	}
}

export namespace ToastErrors {
	export function unknown(): Promise<string> {
		return Toaster.error('An unexpected error occurred. Please try again later.');
	}

	export function fromError(error: unknown, message: string = 'An error occurred: '): Promise<string> {
		let errorText = error;

		if (error instanceof Error)
			errorText = error.message;

		return Toaster.error(message + errorText);
	}
}
